import { gql } from "@apollo/client";



export const CREATE_CUSTOMER = gql`
mutation CreateCustomerOfGeneralInvoice($input: CustomerOfGeneralInvoiceInput) {
  createCustomerOfGeneralInvoice(input: $input) {
    status
    message
  }
}`;


export const UPDATE_CUSTOMER = gql`
mutation UpdateCustomerOfGeneralInvoice($updateCustomerOfGeneralInvoiceId: ID, $input: CustomerOfGeneralInvoiceInput) {
  updateCustomerOfGeneralInvoice(id: $updateCustomerOfGeneralInvoiceId, input: $input) {
    status
    message
  }
}`;


export const DELETE_CUSTOMER = gql`
mutation DeleteCustomerOfGeneralInvoice($deleteCustomerOfGeneralInvoiceId: ID) {
  deleteCustomerOfGeneralInvoice(id: $deleteCustomerOfGeneralInvoiceId) {
    status
    message
  }
}`;






export const GET_CUSTOMER_PAGINATION = gql`
query GetCustomerOfGeneralInvoiceWithPagination($page: Int, $limit: Int, $keyword: String, $pagination: Boolean) {
  getCustomerOfGeneralInvoiceWithPagination(page: $page, limit: $limit, keyword: $keyword, pagination: $pagination) {
    data {
      _id
      customerNameKhmer
      customerNameLatin
      companyName
      type
      note
      email
      gender
      phone
      address
      terms
    }
    paginator {
      slNo
      prev
      next
      perPage
      totalPosts
      totalPages
      currentPage
      hasPrevPage
      hasNextPage
      totalDocs
    }
  }
}
`;

